import { render, staticRenderFns } from "./ProductExchange.vue?vue&type=template&id=442daf2a&"
import script from "./ProductExchange.vue?vue&type=script&lang=ts&"
export * from "./ProductExchange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports